export default __webpack_public_path__ + "static/media/welpentreffen_19.df02b098.jpg";